enum WorkDependencyType {
  // Order is principal. Work Order is dependent.
  OrderToWorkOrder = "OrderToWorkOrder",
  // Order is principal. Order is dependent.
  OrderToOrder = "OrderToOrder",
  OrderToInspection = "OrderToInspection",
  // Work Order is principal. Work Order is dependent.
  WorkOrderToWorkOrder = "WorkOrderToWorkOrder",
  // Work Order is principal. Order is dependent.
  WorkOrderToOrder = "WorkOrderToOrder",
  WorkOrderToInspection = "WorkOrderToInspection",
  InspectionToOrder = "InspectionToOrder",
  InspectionToWorkOrder = "InspectionToWorkOrder",
  InspectionToInspection = "InspectionToInspection",
}

export { WorkDependencyType };
